//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex';
import CategoryPage from '@/components/landing/CategoryPage.vue';
import { getCategoryPage } from '@/api/category.js';
import { listDlpsByCategory } from '@/api/dlp.js';
import { searchElements } from '@/api/search.js';
import { convertRouteToMediaTypeCode } from '@/helpers/mediaType.js';
import seoRedirectMixin from '@/components/mixins/seo-redirect.mixin.js';

export default {
  name: 'category-page-loader',
  mixins: [seoRedirectMixin],
  components: {
    CategoryPage,
  },
  props: {
    mediaTypePath: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mediaTypeName: '',
      metaInfo: {
        title: '',
        description: '',
        seo: {
          title: '',
          description: '',
        },
      },
      mediaType: '',
      isLoaded: false,
    };
  },
  head() {
    return {
      hid: this.metaInfo.seo.title,
      title: this.metaInfo.seo.title,
      meta: this.metaInfo.seo.description ? [{
        name: 'description',
        content: this.metaInfo.seo.description,
      }] : [],
    };
  },
  async fetch() {
    const mediaType = convertRouteToMediaTypeCode(this.mediaTypePath);
    this.mediaType = mediaType;
    this.$store.commit('category/setCategoryTopics', []);

    try {
      const { data: { data } } = await getCategoryPage(this.id, mediaType);
      this.handleSeoRedirect(_.get(data, 'url'));
      this.metaInfo.seo.title = _.get(data, 'html.title');
      this.metaInfo.seo.description = _.get(data, 'html.description');
      this.$store.commit('category/setCategoryData', data);
      if (_.get(data, 'backgroundImage.url')) {
        this.$store.commit('category/setBackgroundImageUrl', _.get(data, 'backgroundImage.url'));
      }
      this.isLoaded = true;

      // Pre-fetch popular + latest elements on SSR for SEO (same pattern as DLP curator picks pre-fetch)
      const searchParams = { page: 1, per_page: 12, category: this.id };
      try {
        const [popularRes, latestRes] = await Promise.all([
          searchElements(mediaType, { ...searchParams, sort: 'popular' }),
          searchElements(mediaType, { ...searchParams, sort: 'latest' }),
        ]);
        const popular = _.get(popularRes, 'data.data');
        const latest = _.get(latestRes, 'data.data');
        if (Array.isArray(popular)) this.$store.commit('category/setPopular', popular);
        if (Array.isArray(latest)) this.$store.commit('category/setLatest', latest);
      } catch (searchErr) {
        if (this.$rollbar) {
          this.$rollbar.error('CategoryPageLoader SSR elements fetch failed', searchErr);
        } else {
          console.error('CategoryPageLoader SSR elements fetch failed:', searchErr);
        }
      }

      try {
        const dlpRes = await listDlpsByCategory(this.id);
        const raw = _.get(dlpRes, 'data.data', _.get(dlpRes, 'data'));
        const list = Array.isArray(raw) ? raw.slice(0, 10) : [];
        this.$store.commit('category/setCategoryTopics', list);
      } catch (dlpErr) {
        this.$store.commit('category/setCategoryTopics', []);
        if (this.$rollbar) {
          this.$rollbar.error('CategoryPageLoader category topics fetch failed', dlpErr);
        } else {
          console.error('CategoryPageLoader category topics fetch failed:', dlpErr);
        }
      }
    } catch (err) {
      const statusCode = _.get(err, 'response.status', 500);
      const message = _.get(err, 'response.data.message', err.message) || 'Failed to load category';
      this.$nuxt.context.error({ statusCode, message });
    }
  },
  fetchOnServer: true,
  computed: {
    ...mapState({
      currentCategory: state => state.category.categoryData,
    }),
    ...mapGetters({
      categoryData: 'category/categoryData',
      latest: 'category/latest',
      popular: 'category/popular',
      title: 'category/title',
      description: 'category/description',
      url: 'category/url',
    }),
    heading() {
      return this.title;
    },
    breadcrumbList() {
      const list = [];
      const mediaTypeGroup = this.mediaType;
      list.push({
        name: this.$term('mediaType', mediaTypeGroup).text(),
        link: this.$link(this.$tools.getChannelUrl(mediaTypeGroup)).url(),
      });
      list.push({
        name: this.heading,
        link: this.url || this.$link(this.$route.path).url(),
      });
      return list;
    },
  },
};
